import { EventEmitter } from 'pixi.js';

let globalEventEmitterInstance = null;

/**
 * Initializes the global event emitter instance.
 * Call this once during your game's main setup.
 * Subsequent calls will return the existing instance.
 *
 * @returns {EventEmitter} The global EventEmitter instance.
 * @example
 * // import { initGlobalEventEmitter } from './utils/globalEventEmitter';
 * // initGlobalEventEmitter();
 */
export function initGlobalEventEmitter() {
  if (!globalEventEmitterInstance) {
    globalEventEmitterInstance = new EventEmitter();
  }
  return globalEventEmitterInstance;
}

/**
 * Retrieves the global event emitter instance.
 * Ensure `initGlobalEventEmitter()` is called during game setup before using this.
 *
 * @returns {EventEmitter} The global EventEmitter instance.
 * @throws {Error} If the emitter has not been initialized.
 * @example
 * // import { getGlobalEventEmitter } from './utils/globalEventEmitter';
 * // const gameEvents = getGlobalEventEmitter();
 * // gameEvents.emit('playerAction', { action: 'jump' });
 */
export function getGlobalEventEmitter() {
  if (!globalEventEmitterInstance) {
    console.warn('GlobalEventEmitter not initialized. Call initGlobalEventEmitter() first.');
  }
  return globalEventEmitterInstance;
}

/**
 * Cleans up the global event emitter.
 * Call this during game shutdown to remove listeners and reset the instance.
 *
 * @example
 * // import { cleanupGlobalEventEmitter } from './utils/globalEventEmitter';
 * // cleanupGlobalEventEmitter();
 */
export function cleanupGlobalEventEmitter() {
  if (globalEventEmitterInstance) {
    globalEventEmitterInstance.removeAllListeners();
    globalEventEmitterInstance = null;
  }
}

// Remove the previous direct instantiation and default export:
// const globalEventEmitter = new EventEmitter(); // REMOVED
// export default globalEventEmitter; // REMOVED 